import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import logger from './logger';
import store from './store';
import VueCookies from 'vue-cookies';
import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import ko from './locales/ko.json';

import AOS from 'aos';
import VueDragscroll from 'vue-dragscroll'; // 참조 : https://vue-dragscroll.clebinfosys.com/
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ConfirmDialog from 'primevue/confirmdialog';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import mitt from 'mitt';
import Global from '@/components/Global';
import './assets/css/type.css';
import './assets/css/reset.css';
import './assets/scss/main.scss';
import 'aos/dist/aos.css';
import '@vueup/vue-quill/dist/vue-quill.snow.css';

const lan = navigator.language.split('-');
// console.log(['===== navigator.language : ', navigator.language, lan, lan.at(0)]);
// console.log(['===== navigator.language : ', navigator.language, lan, lan.at(0)]);

const currentLocale = store.getters.getCurrentLocale;
// console.log(['===== current locale : ', currentLocale]);

const browserLocale = lan.at(0) === 'en' || lan.at(0) === 'ko' ? lan.at(0) : 'en';

const i18n = createI18n({
  locale: currentLocale ? currentLocale : browserLocale,
  fallbackLocale: 'ko',
  messages: { en, ko },
  allowComposition: true,
  warnHtmlInMessage: 'off', // disable of the Detected HTML in message
});

const emitter = mitt();

const pinia = createPinia();
const app = createApp(App);
app.config.globalProperties.emitter = emitter;
app.config.globalProperties.execDaumPostcode = Global.execDaumPostcode;
app.config.globalProperties.formatBytes = Global.formatBytes;
app.config.globalProperties.fileToImg = Global.fileToImg;
app.config.globalProperties.splitComma = Global.splitComma;
app.config.globalProperties.isDev = Global.isDev;
app.config.globalProperties.gbFnReplaceXss = Global.gbFnReplaceXss;
app.config.globalProperties.IMG_URL = process.env.VUE_APP_IMG_URL;
const emailComp = ['naver.com', 'gmail.com', 'daum.net', 'hanmail.net', 'nate.com', 'hotmail.com', 'icloud.com'];
app.config.globalProperties.EMAIL_COMP = emailComp;
const countries = [
  { nation: '한국(+82)', code: '82' },
  { nation: 'USA/Canada(+1)', code: '1' },
  { nation: 'UAE(+971)', code: '971' },
  { nation: 'Afghanistan(+93)', code: '93' },
  { nation: 'Albania(+355)', code: '355' },
  { nation: 'Armenia(+374)', code: '374' },
  { nation: 'Austria(+43)', code: '43' },
  { nation: 'Australia(+61)', code: '61' },
  { nation: 'Azerbaijan(+994)', code: '994' },
  { nation: 'Bosnia(+387)', code: '387' },
  { nation: 'Bangladesh(+880)', code: '880' },
  { nation: 'Belgium(+32)', code: '32' },
  { nation: 'Bulgaria(+359)', code: '359' },
  { nation: 'Bahrain(+973)', code: '973' },
  { nation: 'Brunei(+673)', code: '673' },
  { nation: 'Belarus(+3755)', code: '3755' },
  { nation: 'Swiss(+41)', code: '41' },
  { nation: 'China(+86)', code: '86' },
  { nation: 'Cyprus(+357)', code: '357' },
  { nation: 'Czech Republic(+420)', code: '420' },
  { nation: 'Germany(+49)', code: '49' },
  { nation: 'Denmark(+45)', code: '45' },
  { nation: 'Estonia(+372)', code: '372' },
  { nation: 'Egypt(+20)', code: '20' },
  { nation: 'Spain(+34)', code: '34' },
  { nation: 'Finland(+358)', code: '358' },
  { nation: 'France(+33)', code: '33' },
  { nation: 'England(+44)', code: '44' },
  { nation: 'Greece(+30)', code: '30' },
  { nation: 'Hong Kong(+852)', code: '852' },
  { nation: 'Croatia(+385)', code: '385' },
  { nation: 'Hungary(+36)', code: '36' },
  { nation: 'Indonesia(+62)', code: '62' },
  { nation: 'Ireland(+353)', code: '353' },
  { nation: 'Israel(+972)', code: '972' },
  { nation: 'India(+91)', code: '91' },
  { nation: 'Italy(+39)', code: '39' },
  { nation: 'Jordan(+962)', code: '962' },
  { nation: 'Japan(+81)', code: '81' },
  { nation: 'Kyrgyzstan(+996)', code: '996' },
  { nation: 'Cambodia(+855)', code: '855' },
  { nation: 'Kuwait(+965)', code: '965' },
  { nation: 'Laos(+856)', code: '856' },
  { nation: 'Lebanon(+961)', code: '961' },
  { nation: 'Lithuania(+370)', code: '370' },
  { nation: 'Luxembourg(+352)', code: '352' },
  { nation: 'Latvia(+371)', code: '371' },
  { nation: 'Macedonia(+389)', code: '389' },
  { nation: 'Myanmar(+95)', code: '95' },
  { nation: 'Macau(+853)', code: '853' },
  { nation: 'Malta(+356)', code: '356' },
  { nation: 'Malaysia(+60)', code: '60' },
  { nation: 'Netherlands(+31)', code: '31' },
  { nation: 'Norway(+47)', code: '47' },
  { nation: 'New Zealand(+64)', code: '64' },
  { nation: 'Oman(+968)', code: '968' },
  { nation: 'Papua New Guinea(+675)', code: '675' },
  { nation: 'Philippine(+63)', code: '63' },
  { nation: 'Pakistan(+92)', code: '92' },
  { nation: 'Poland(+48)', code: '48' },
  { nation: 'Portugal(+351)', code: '351' },
  { nation: 'Romania(+40)', code: '40' },
  { nation: 'Serbia(+381)', code: '381' },
  { nation: 'Russia(+7)', code: '7' },
  { nation: 'Saudi Arabia(+966)', code: '966' },
  { nation: 'Sweden(+46)', code: '46' },
  { nation: 'Singapore(+65)', code: '65' },
  { nation: 'Slovenian(+386)', code: '386' },
  { nation: 'Slovakia(+421)', code: '421' },
  { nation: 'Thailand(+66)', code: '66' },
  { nation: 'Tajikistan(+992)', code: '992' },
  { nation: 'Turkmenistan(+993)', code: '993' },
  { nation: 'Turkey(+90)', code: '90' },
  { nation: 'Taiwan(+886)', code: '886' },
  { nation: 'Ukraine(+380)', code: '380' },
  { nation: 'Uzbekistan(+998)', code: '998' },
  { nation: 'Vietnam(+84)', code: '84' },
  { nation: 'Yemen(+967)', code: '967' },
];
app.config.globalProperties.countries = countries;
const nations = [
  { name: 'Korea, Republic of', code: 'KR' },
  { name: 'United States', code: 'US' },
  { name: 'Afghanistan', code: 'AF' },
  { name: 'Albania', code: 'AL' },
  { name: 'Algeria', code: 'DZ' },
  { name: 'American Samoa', code: 'AS' },
  { name: 'Andorra', code: 'AD' },
  { name: 'Angola', code: 'AO' },
  { name: 'Anguilla', code: 'AI' },
  { name: 'Antarctica', code: 'AQ' },
  { name: 'Antigua and Barbuda', code: 'AG' },
  { name: 'Argentina', code: 'AR' },
  { name: 'Armenia', code: 'AM' },
  { name: 'Aruba', code: 'AW' },
  { name: 'Australia', code: 'AU' },
  { name: 'Austria', code: 'AT' },
  { name: 'Azerbaijan', code: 'AZ' },
  { name: 'Bahamas', code: 'BS' },
  { name: 'Bahrain', code: 'BH' },
  { name: 'Bangladesh', code: 'BD' },
  { name: 'Barbados', code: 'BB' },
  { name: 'Belarus', code: 'BY' },
  { name: 'Belgium', code: 'BE' },
  { name: 'Belize', code: 'BZ' },
  { name: 'Benin', code: 'BJ' },
  { name: 'Bermuda', code: 'BM' },
  { name: 'Bhutan', code: 'BT' },
  { name: 'Bolivia', code: 'BO' },
  { name: 'Bosnia and Herzegovina', code: 'BA' },
  { name: 'Botswana', code: 'BW' },
  { name: 'Bouvet Island', code: 'BV' },
  { name: 'Brazil', code: 'BR' },
  { name: 'British Indian Ocean Territory', code: 'IO' },
  { name: 'Brunei Darussalam', code: 'BN' },
  { name: 'Bulgaria', code: 'BG' },
  { name: 'Burkina Faso', code: 'BF' },
  { name: 'Burundi', code: 'BI' },
  { name: 'Cambodia', code: 'KH' },
  { name: 'Cameroon', code: 'CM' },
  { name: 'Canada', code: 'CA' },
  { name: 'Cape Verde', code: 'CV' },
  { name: 'Cayman Islands', code: 'KY' },
  { name: 'Central African Republic', code: 'CF' },
  { name: 'Chad', code: 'TD' },
  { name: 'Chile', code: 'CL' },
  { name: 'China', code: 'CN' },
  { name: 'Christmas Island', code: 'CX' },
  { name: 'Cocos (Keeling) Islands', code: 'CC' },
  { name: 'Colombia', code: 'CO' },
  { name: 'Comoros', code: 'KM' },
  { name: 'Congo', code: 'CG' },
  { name: 'Congo, The Democratic Republic of the', code: 'CD' },
  { name: 'Cook Islands', code: 'CK' },
  { name: 'Costa Rica', code: 'CR' },
  { name: 'Cote D"Ivoire', code: 'CI' },
  { name: 'Croatia', code: 'HR' },
  { name: 'Cuba', code: 'CU' },
  { name: 'Cyprus', code: 'CY' },
  { name: 'Czech Republic', code: 'CZ' },
  { name: 'Denmark', code: 'DK' },
  { name: 'Djibouti', code: 'DJ' },
  { name: 'Dominica', code: 'DM' },
  { name: 'Dominican Republic', code: 'DO' },
  { name: 'Ecuador', code: 'EC' },
  { name: 'Egypt', code: 'EG' },
  { name: 'El Salvador', code: 'SV' },
  { name: 'Equatorial Guinea', code: 'GQ' },
  { name: 'Eritrea', code: 'ER' },
  { name: 'Estonia', code: 'EE' },
  { name: 'Ethiopia', code: 'ET' },
  { name: 'Falkland Islands (Malvinas)', code: 'FK' },
  { name: 'Faroe Islands', code: 'FO' },
  { name: 'Fiji', code: 'FJ' },
  { name: 'Finland', code: 'FI' },
  { name: 'France', code: 'FR' },
  { name: 'French Guiana', code: 'GF' },
  { name: 'French Polynesia', code: 'PF' },
  { name: 'French Southern Territories', code: 'TF' },
  { name: 'Gabon', code: 'GA' },
  { name: 'Gambia', code: 'GM' },
  { name: 'Georgia', code: 'GE' },
  { name: 'Germany', code: 'DE' },
  { name: 'Ghana', code: 'GH' },
  { name: 'Gibraltar', code: 'GI' },
  { name: 'Greece', code: 'GR' },
  { name: 'Greenland', code: 'GL' },
  { name: 'Grenada', code: 'GD' },
  { name: 'Guadeloupe', code: 'GP' },
  { name: 'Guam', code: 'GU' },
  { name: 'Guatemala', code: 'GT' },
  { name: 'Guernsey', code: 'GG' },
  { name: 'Guinea', code: 'GN' },
  { name: 'Guinea-Bissau', code: 'GW' },
  { name: 'Guyana', code: 'GY' },
  { name: 'Haiti', code: 'HT' },
  { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
  { name: 'Holy See (Vatican City State)', code: 'VA' },
  { name: 'Honduras', code: 'HN' },
  { name: 'Hong Kong', code: 'HK' },
  { name: 'Hungary', code: 'HU' },
  { name: 'Iceland', code: 'IS' },
  { name: 'India', code: 'IN' },
  { name: 'Indonesia', code: 'ID' },
  { name: 'Iran, Islamic Republic Of', code: 'IR' },
  { name: 'Iraq', code: 'IQ' },
  { name: 'Ireland', code: 'IE' },
  { name: 'Isle of Man', code: 'IM' },
  { name: 'Israel', code: 'IL' },
  { name: 'Italy', code: 'IT' },
  { name: 'Jamaica', code: 'JM' },
  { name: 'Japan', code: 'JP' },
  { name: 'Jersey', code: 'JE' },
  { name: 'Jordan', code: 'JO' },
  { name: 'Kazakhstan', code: 'KZ' },
  { name: 'Kenya', code: 'KE' },
  { name: 'Kiribati', code: 'KI' },
  { name: 'Korea, Democratic People"S Republic of', code: 'KP' },
  { name: 'Kuwait', code: 'KW' },
  { name: 'Kyrgyzstan', code: 'KG' },
  { name: 'Lao People"S Democratic Republic', code: 'LA' },
  { name: 'Latvia', code: 'LV' },
  { name: 'Lebanon', code: 'LB' },
  { name: 'Lesotho', code: 'LS' },
  { name: 'Liberia', code: 'LR' },
  { name: 'Libyan Arab Jamahiriya', code: 'LY' },
  { name: 'Liechtenstein', code: 'LI' },
  { name: 'Lithuania', code: 'LT' },
  { name: 'Luxembourg', code: 'LU' },
  { name: 'Macao', code: 'MO' },
  { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
  { name: 'Madagascar', code: 'MG' },
  { name: 'Malawi', code: 'MW' },
  { name: 'Malaysia', code: 'MY' },
  { name: 'Maldives', code: 'MV' },
  { name: 'Mali', code: 'ML' },
  { name: 'Malta', code: 'MT' },
  { name: 'Marshall Islands', code: 'MH' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mauritania', code: 'MR' },
  { name: 'Mauritius', code: 'MU' },
  { name: 'Mayotte', code: 'YT' },
  { name: 'Mexico', code: 'MX' },
  { name: 'Micronesia, Federated States of', code: 'FM' },
  { name: 'Moldova, Republic of', code: 'MD' },
  { name: 'Monaco', code: 'MC' },
  { name: 'Mongolia', code: 'MN' },
  { name: 'Montserrat', code: 'MS' },
  { name: 'Morocco', code: 'MA' },
  { name: 'Mozambique', code: 'MZ' },
  { name: 'Myanmar', code: 'MM' },
  { name: 'Namibia', code: 'NA' },
  { name: 'Nauru', code: 'NR' },
  { name: 'Nepal', code: 'NP' },
  { name: 'Netherlands', code: 'NL' },
  { name: 'Netherlands Antilles', code: 'AN' },
  { name: 'New Caledonia', code: 'NC' },
  { name: 'New Zealand', code: 'NZ' },
  { name: 'Nicaragua', code: 'NI' },
  { name: 'Niger', code: 'NE' },
  { name: 'Nigeria', code: 'NG' },
  { name: 'Niue', code: 'NU' },
  { name: 'Norfolk Island', code: 'NF' },
  { name: 'Northern Mariana Islands', code: 'MP' },
  { name: 'Norway', code: 'NO' },
  { name: 'Oman', code: 'OM' },
  { name: 'Pakistan', code: 'PK' },
  { name: 'Palau', code: 'PW' },
  { name: 'Palestinian Territory, Occupied', code: 'PS' },
  { name: 'Panama', code: 'PA' },
  { name: 'Papua New Guinea', code: 'PG' },
  { name: 'Paraguay', code: 'PY' },
  { name: 'Peru', code: 'PE' },
  { name: 'Philippines', code: 'PH' },
  { name: 'Pitcairn', code: 'PN' },
  { name: 'Poland', code: 'PL' },
  { name: 'Portugal', code: 'PT' },
  { name: 'Puerto Rico', code: 'PR' },
  { name: 'Qatar', code: 'QA' },
  { name: 'Reunion', code: 'RE' },
  { name: 'Romania', code: 'RO' },
  { name: 'Russian Federation', code: 'RU' },
  { name: 'RWANDA', code: 'RW' },
  { name: 'Saint Helena', code: 'SH' },
  { name: 'Saint Kitts and Nevis', code: 'KN' },
  { name: 'Saint Lucia', code: 'LC' },
  { name: 'Saint Pierre and Miquelon', code: 'PM' },
  { name: 'Saint Vincent and the Grenadines', code: 'VC' },
  { name: 'Samoa', code: 'WS' },
  { name: 'San Marino', code: 'SM' },
  { name: 'Sao Tome and Principe', code: 'ST' },
  { name: 'Saudi Arabia', code: 'SA' },
  { name: 'Senegal', code: 'SN' },
  { name: 'Serbia and Montenegro', code: 'CS' },
  { name: 'Seychelles', code: 'SC' },
  { name: 'Sierra Leone', code: 'SL' },
  { name: 'Singapore', code: 'SG' },
  { name: 'Slovakia', code: 'SK' },
  { name: 'Slovenia', code: 'SI' },
  { name: 'Solomon Islands', code: 'SB' },
  { name: 'Somalia', code: 'SO' },
  { name: 'South Africa', code: 'ZA' },
  { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
  { name: 'Spain', code: 'ES' },
  { name: 'Sri Lanka', code: 'LK' },
  { name: 'Sudan', code: 'SD' },
  { name: 'Suriname', code: 'SR' },
  { name: 'Svalbard and Jan Mayen', code: 'SJ' },
  { name: 'Swaziland', code: 'SZ' },
  { name: 'Sweden', code: 'SE' },
  { name: 'Switzerland', code: 'CH' },
  { name: 'Syrian Arab Republic', code: 'SY' },
  { name: 'Taiwan, Province of China', code: 'TW' },
  { name: 'Tajikistan', code: 'TJ' },
  { name: 'Tanzania, United Republic of', code: 'TZ' },
  { name: 'Thailand', code: 'TH' },
  { name: 'Timor-Leste', code: 'TL' },
  { name: 'Togo', code: 'TG' },
  { name: 'Tokelau', code: 'TK' },
  { name: 'Tonga', code: 'TO' },
  { name: 'Trinidad and Tobago', code: 'TT' },
  { name: 'Tunisia', code: 'TN' },
  { name: 'Turkey', code: 'TR' },
  { name: 'Turkmenistan', code: 'TM' },
  { name: 'Turks and Caicos Islands', code: 'TC' },
  { name: 'Tuvalu', code: 'TV' },
  { name: 'Uganda', code: 'UG' },
  { name: 'Ukraine', code: 'UA' },
  { name: 'United Arab Emirates', code: 'AE' },
  { name: 'United Kingdom', code: 'GB' },
  { name: 'United States Minor Outlying Islands', code: 'UM' },
  { name: 'Uruguay', code: 'UY' },
  { name: 'Uzbekistan', code: 'UZ' },
  { name: 'Vanuatu', code: 'VU' },
  { name: 'Venezuela', code: 'VE' },
  { name: 'Viet Nam', code: 'VN' },
  { name: 'Virgin Islands, British', code: 'VG' },
  { name: 'Virgin Islands, U.S.', code: 'VI' },
  { name: 'Wallis and Futuna', code: 'WF' },
  { name: 'Western Sahara', code: 'EH' },
  { name: 'Yemen', code: 'YE' },
  { name: 'Zambia', code: 'ZM' },
  { name: 'Zimbabwe', code: 'ZW' },
];
app.config.globalProperties.nations = nations;
app
  .use(pinia)
  .use(router)
  .use(logger)
  .use(store)
  .use(mitt)
  // .use(VueCookies, { expireTimes: '2h', secure: true })
  .use(VueCookies, { expireTimes: '2h' })
  .use(PrimeVue)
  .use(ConfirmationService)
  .use(i18n)
  .use(AOS.init())
  .use(VueDragscroll)
  .component('ConfirmDialog', ConfirmDialog)
  .component('Accordion', Accordion)
  .component('AccordionTab', AccordionTab)
  .mount('#app');
